import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/login-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-f92ff7c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  class: "section1",
  style: {}
}
const _hoisted_3 = {
  class: "section",
  style: {}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Aboitiz logo",
  src: _imports_0,
  style: {"max-width":"357px"}
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "PAYMENT STATUS PORTAL", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Vendor", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding":"6px"} }, "Back to login", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_result = _resolveComponent("a-result")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_a_result, {
          status: "404",
          title: "404",
          "sub-title": "Sorry, the page you visited does not exist."
        }, {
          extra: _withCtx(() => [
            _createVNode(_component_a_button, {
              class: "login-btn",
              "html-type": "submit",
              type: "primary",
              href: "/login"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}